/*
 * Interface strings for the "chrome" area. Keys are the Russian source strings exactly as they
 * appear in the components; a missing key falls back to Russian, so a partial dictionary is safe.
 * Russian itself is never listed here — it is the key.
 */
const chrome = {
  english: {
    'Новости и обновления платформы {0}.': 'News and updates from the {0} platform.',
    /* SiteHeader — nav */
    'Поиск': 'Search',
    'Профиль': 'Profile',
    'Библиотека': 'Library',
    'Создать новеллу': 'Create novel',
    'Оплата': 'Payment',
    'Блог': 'Blog',
    'Новости': 'News',
    'Стать автором': 'Become an author',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Discover your universe',
    'Открыть меню': 'Open menu',
    'Закрыть меню': 'Close menu',
    'Меню навигации': 'Navigation menu',
    'Закрыть уведомление': 'Close notification',
    'Читать': 'Read',
    'Важные новости': 'Important news',
    'Нажмите, чтобы прочитать': 'Tap to read',
    'Сообщить об ошибке / задать вопрос': 'Report a bug / ask a question',
    /* SiteFooter */
    'О нас': 'About us',
    'Сотрудничество': 'Partnership',
    'Пользовательское соглашение': 'Terms of Use',
    'Политика конфиденциальности': 'Privacy Policy',
    'Согласие на Cookie': 'Cookie Consent',
    'Публичная оферта': 'Public Offer',
    'Политика возврата': 'Refund Policy',
    'Правообладателям': 'Copyright & DMCA',
    'Индивидуальный предприниматель': 'Sole proprietor',
    /* ReportModal */
    'Сообщение отправлено': 'Message sent',
    'Ошибка при отправке': 'Failed to send',
    'Отправить': 'Send',
    'Мои обращения': 'My requests',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Describe the problem or ask a question — an admin will get back to you soon.',
    'Ваше сообщение...': 'Your message...',
    'Отправка...': 'Sending...',
    'Загрузка...': 'Loading...',
    'Обращений нет': 'No requests yet',
    'Ответ администратора:': 'Admin response:',
    'Администратор скоро Вам ответит': 'An admin will get back to you soon',
    /* Modal */
    'Закрыть': 'Close',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'By continuing to use the site, you',
    'соглашаетесь': 'agree',
    'на использование файлов Cookie': 'to the use of cookies',
    'Принять': 'Accept',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Platform updates and announcements',
    'Новостей пока нет': 'No news yet',
    'Новое': 'New',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'News, updates and articles from the AI Novel team',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Scheduled maintenance is in progress. Please come back later.',
    'Обновить': 'Refresh',
    /* apiUtils — server errors */
    'Пользователь не найден': 'User not found',
    'Имя пользователя должно содержать от 3 до 20 символов': 'Username must be between 3 and 20 characters',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'Username can only contain letters, digits and underscores',
    'Имя пользователя уже зарегистрировано': 'This username is already taken',
    'Неверное имя пользователя или пароль': 'Incorrect username or password',
    'Новелла не найдена': 'Novel not found',
    'Неверный ключ администратора': 'Invalid admin key',
    'Неверный код верификации': 'Invalid verification code',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Only registered users can like novels. Please create an account to like this novel.',
    'Попробуйте снова или позже ({0})': 'Please try again later ({0})',
  },

  german: {
    'Новости и обновления платформы {0}.': 'Neuigkeiten und Updates von der Plattform {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Suche',
    'Профиль': 'Profil',
    'Библиотека': 'Bibliothek',
    'Создать новеллу': 'Novel erstellen',
    'Оплата': 'Zahlung',
    'Блог': 'Blog',
    'Новости': 'News',
    'Стать автором': 'Autor werden',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Entdecke dein Universum',
    'Открыть меню': 'Menü öffnen',
    'Закрыть меню': 'Menü schließen',
    'Меню навигации': 'Navigationsmenü',
    'Закрыть уведомление': 'Benachrichtigung schließen',
    'Читать': 'Lesen',
    'Важные новости': 'Wichtige News',
    'Нажмите, чтобы прочитать': 'Zum Lesen tippen',
    'Сообщить об ошибке / задать вопрос': 'Fehler melden / Frage stellen',
    /* SiteFooter */
    'О нас': 'Über uns',
    'Сотрудничество': 'Zusammenarbeit',
    'Пользовательское соглашение': 'Nutzungsbedingungen',
    'Политика конфиденциальности': 'Datenschutzerklärung',
    'Согласие на Cookie': 'Cookie-Einwilligung',
    'Публичная оферта': 'Öffentliches Angebot',
    'Политика возврата': 'Rückerstattungsrichtlinie',
    'Правообладателям': 'Urheberrecht & DMCA',
    'Индивидуальный предприниматель': 'Einzelunternehmer',
    /* ReportModal */
    'Сообщение отправлено': 'Nachricht gesendet',
    'Ошибка при отправке': 'Fehler beim Senden',
    'Отправить': 'Senden',
    'Мои обращения': 'Meine Anfragen',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Beschreiben Sie das Problem oder stellen Sie eine Frage — ein Administrator antwortet Ihnen bald.',
    'Ваше сообщение...': 'Ihre Nachricht...',
    'Отправка...': 'Wird gesendet...',
    'Загрузка...': 'Wird geladen...',
    'Обращений нет': 'Keine Anfragen',
    'Ответ администратора:': 'Antwort des Administrators:',
    'Администратор скоро Вам ответит': 'Ein Administrator antwortet Ihnen bald',
    /* Modal */
    'Закрыть': 'Schließen',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'Wenn Sie die Website weiterhin nutzen,',
    'соглашаетесь': 'stimmen Sie',
    'на использование файлов Cookie': 'der Verwendung von Cookies zu',
    'Принять': 'Akzeptieren',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Updates und Ankündigungen der Plattform',
    'Новостей пока нет': 'Noch keine News',
    'Новое': 'Neu',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'News, Updates und Artikel vom AI-Novel-Team',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Es werden Wartungsarbeiten durchgeführt. Bitte schauen Sie später wieder vorbei.',
    'Обновить': 'Aktualisieren',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Benutzer nicht gefunden',
    'Имя пользователя должно содержать от 3 до 20 символов': 'Der Benutzername muss zwischen 3 und 20 Zeichen lang sein',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'Der Benutzername darf nur Buchstaben, Ziffern und Unterstriche enthalten',
    'Имя пользователя уже зарегистрировано': 'Dieser Benutzername ist bereits vergeben',
    'Неверное имя пользователя или пароль': 'Benutzername oder Passwort ist falsch',
    'Новелла не найдена': 'Novel nicht gefunden',
    'Неверный ключ администратора': 'Ungültiger Administratorschlüssel',
    'Неверный код верификации': 'Ungültiger Bestätigungscode',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Nur registrierte Nutzer können Novels liken. Bitte erstellen Sie ein Konto, um diese Novel zu liken.',
    'Попробуйте снова или позже ({0})': 'Bitte versuchen Sie es später erneut ({0})',
  },

  french: {
    'Новости и обновления платформы {0}.': 'Actualités et mises à jour de la plateforme {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Recherche',
    'Профиль': 'Profil',
    'Библиотека': 'Bibliothèque',
    'Создать новеллу': 'Créer un roman',
    'Оплата': 'Paiement',
    'Блог': 'Blog',
    'Новости': 'Actualités',
    'Стать автором': 'Devenir auteur',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Découvre ton univers',
    'Открыть меню': 'Ouvrir le menu',
    'Закрыть меню': 'Fermer le menu',
    'Меню навигации': 'Menu de navigation',
    'Закрыть уведомление': 'Fermer la notification',
    'Читать': 'Lire',
    'Важные новости': 'Actualités importantes',
    'Нажмите, чтобы прочитать': 'Appuyez pour lire',
    'Сообщить об ошибке / задать вопрос': 'Signaler un bug / poser une question',
    /* SiteFooter */
    'О нас': 'À propos',
    'Сотрудничество': 'Partenariat',
    'Пользовательское соглашение': 'Conditions d’utilisation',
    'Политика конфиденциальности': 'Politique de confidentialité',
    'Согласие на Cookie': 'Consentement aux cookies',
    'Публичная оферта': 'Offre publique',
    'Политика возврата': 'Politique de remboursement',
    'Правообладателям': "Droit d'auteur et DMCA",
    'Индивидуальный предприниматель': 'Entrepreneur individuel',
    /* ReportModal */
    'Сообщение отправлено': 'Message envoyé',
    'Ошибка при отправке': 'Erreur lors de l’envoi',
    'Отправить': 'Envoyer',
    'Мои обращения': 'Mes demandes',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Décrivez le problème ou posez une question — un administrateur vous répondra bientôt.',
    'Ваше сообщение...': 'Votre message...',
    'Отправка...': 'Envoi...',
    'Загрузка...': 'Chargement...',
    'Обращений нет': 'Aucune demande',
    'Ответ администратора:': 'Réponse de l’administrateur :',
    'Администратор скоро Вам ответит': 'Un administrateur vous répondra bientôt',
    /* Modal */
    'Закрыть': 'Fermer',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'En continuant à utiliser le site, vous',
    'соглашаетесь': 'acceptez',
    'на использование файлов Cookie': 'l’utilisation des cookies',
    'Принять': 'Accepter',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Mises à jour et annonces de la plateforme',
    'Новостей пока нет': 'Pas encore d’actualités',
    'Новое': 'Nouveau',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'Actualités, mises à jour et articles de l’équipe AI Novel',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Maintenance en cours. Merci de revenir plus tard.',
    'Обновить': 'Actualiser',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Utilisateur introuvable',
    'Имя пользователя должно содержать от 3 до 20 символов': 'Le nom d’utilisateur doit contenir entre 3 et 20 caractères',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'Le nom d’utilisateur ne peut contenir que des lettres, des chiffres et des tirets bas',
    'Имя пользователя уже зарегистрировано': 'Ce nom d’utilisateur est déjà pris',
    'Неверное имя пользователя или пароль': 'Nom d’utilisateur ou mot de passe incorrect',
    'Новелла не найдена': 'Roman introuvable',
    'Неверный ключ администратора': 'Clé administrateur invalide',
    'Неверный код верификации': 'Code de vérification invalide',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Seuls les utilisateurs inscrits peuvent aimer les romans. Créez un compte pour aimer ce roman.',
    'Попробуйте снова или позже ({0})': 'Veuillez réessayer plus tard ({0})',
  },

  spanish: {
    'Новости и обновления платформы {0}.': 'Noticias y novedades de la plataforma {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Buscar',
    'Профиль': 'Perfil',
    'Библиотека': 'Biblioteca',
    'Создать новеллу': 'Crear novela',
    'Оплата': 'Pagos',
    'Блог': 'Blog',
    'Новости': 'Noticias',
    'Стать автором': 'Ser autor',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Descubre tu universo',
    'Открыть меню': 'Abrir el menú',
    'Закрыть меню': 'Cerrar el menú',
    'Меню навигации': 'Menú de navegación',
    'Закрыть уведомление': 'Cerrar la notificación',
    'Читать': 'Leer',
    'Важные новости': 'Noticias importantes',
    'Нажмите, чтобы прочитать': 'Toca para leer',
    'Сообщить об ошибке / задать вопрос': 'Reportar un error / hacer una pregunta',
    /* SiteFooter */
    'О нас': 'Sobre nosotros',
    'Сотрудничество': 'Colaboración',
    'Пользовательское соглашение': 'Términos de uso',
    'Политика конфиденциальности': 'Política de privacidad',
    'Согласие на Cookie': 'Consentimiento de cookies',
    'Публичная оферта': 'Oferta pública',
    'Политика возврата': 'Política de reembolso',
    'Правообладателям': 'Derechos de autor y DMCA',
    'Индивидуальный предприниматель': 'Empresario individual',
    /* ReportModal */
    'Сообщение отправлено': 'Mensaje enviado',
    'Ошибка при отправке': 'Error al enviar',
    'Отправить': 'Enviar',
    'Мои обращения': 'Mis solicitudes',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Describe el problema o haz una pregunta — un administrador te responderá pronto.',
    'Ваше сообщение...': 'Tu mensaje...',
    'Отправка...': 'Enviando...',
    'Загрузка...': 'Cargando...',
    'Обращений нет': 'No hay solicitudes',
    'Ответ администратора:': 'Respuesta del administrador:',
    'Администратор скоро Вам ответит': 'Un administrador te responderá pronto',
    /* Modal */
    'Закрыть': 'Cerrar',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'Al continuar usando el sitio,',
    'соглашаетесь': 'aceptas',
    'на использование файлов Cookie': 'el uso de cookies',
    'Принять': 'Aceptar',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Actualizaciones y anuncios de la plataforma',
    'Новостей пока нет': 'Aún no hay noticias',
    'Новое': 'Nuevo',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'Noticias, actualizaciones y artículos del equipo de AI Novel',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Estamos en mantenimiento. Por favor, vuelve más tarde.',
    'Обновить': 'Actualizar',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Usuario no encontrado',
    'Имя пользователя должно содержать от 3 до 20 символов': 'El nombre de usuario debe tener entre 3 y 20 caracteres',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'El nombre de usuario solo puede contener letras, números y guiones bajos',
    'Имя пользователя уже зарегистрировано': 'Este nombre de usuario ya está en uso',
    'Неверное имя пользователя или пароль': 'Nombre de usuario o contraseña incorrectos',
    'Новелла не найдена': 'Novela no encontrada',
    'Неверный ключ администратора': 'Clave de administrador no válida',
    'Неверный код верификации': 'Código de verificación no válido',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Solo los usuarios registrados pueden dar me gusta a las novelas. Crea una cuenta para dar me gusta a esta novela.',
    'Попробуйте снова или позже ({0})': 'Inténtalo de nuevo más tarde ({0})',
  },

  italian: {
    'Новости и обновления платформы {0}.': 'Notizie e aggiornamenti della piattaforma {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Cerca',
    'Профиль': 'Profilo',
    'Библиотека': 'Libreria',
    'Создать новеллу': 'Crea novel',
    'Оплата': 'Pagamenti',
    'Блог': 'Blog',
    'Новости': 'Notizie',
    'Стать автором': 'Diventa autore',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Scopri il tuo universo',
    'Открыть меню': 'Apri il menu',
    'Закрыть меню': 'Chiudi il menu',
    'Меню навигации': 'Menu di navigazione',
    'Закрыть уведомление': 'Chiudi la notifica',
    'Читать': 'Leggi',
    'Важные новости': 'Notizie importanti',
    'Нажмите, чтобы прочитать': 'Tocca per leggere',
    'Сообщить об ошибке / задать вопрос': 'Segnala un errore / fai una domanda',
    /* SiteFooter */
    'О нас': 'Chi siamo',
    'Сотрудничество': 'Collaborazione',
    'Пользовательское соглашение': 'Termini di utilizzo',
    'Политика конфиденциальности': 'Informativa sulla privacy',
    'Согласие на Cookie': 'Consenso ai cookie',
    'Публичная оферта': 'Offerta pubblica',
    'Политика возврата': 'Politica di rimborso',
    'Правообладателям': "Diritto d'autore e DMCA",
    'Индивидуальный предприниматель': 'Imprenditore individuale',
    /* ReportModal */
    'Сообщение отправлено': 'Messaggio inviato',
    'Ошибка при отправке': 'Errore durante l’invio',
    'Отправить': 'Invia',
    'Мои обращения': 'Le mie richieste',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Descrivi il problema o fai una domanda — un amministratore ti risponderà presto.',
    'Ваше сообщение...': 'Il tuo messaggio...',
    'Отправка...': 'Invio...',
    'Загрузка...': 'Caricamento...',
    'Обращений нет': 'Nessuna richiesta',
    'Ответ администратора:': 'Risposta dell’amministratore:',
    'Администратор скоро Вам ответит': 'Un amministratore ti risponderà presto',
    /* Modal */
    'Закрыть': 'Chiudi',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'Continuando a usare il sito,',
    'соглашаетесь': 'accetti',
    'на использование файлов Cookie': 'l’uso dei cookie',
    'Принять': 'Accetta',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Aggiornamenti e annunci della piattaforma',
    'Новостей пока нет': 'Ancora nessuna notizia',
    'Новое': 'Nuovo',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'Notizie, aggiornamenti e articoli dal team di AI Novel',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Manutenzione in corso. Torna più tardi, per favore.',
    'Обновить': 'Aggiorna',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Utente non trovato',
    'Имя пользователя должно содержать от 3 до 20 символов': 'Il nome utente deve contenere tra 3 e 20 caratteri',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'Il nome utente può contenere solo lettere, numeri e trattini bassi',
    'Имя пользователя уже зарегистрировано': 'Questo nome utente è già in uso',
    'Неверное имя пользователя или пароль': 'Nome utente o password non corretti',
    'Новелла не найдена': 'Novel non trovata',
    'Неверный ключ администратора': 'Chiave amministratore non valida',
    'Неверный код верификации': 'Codice di verifica non valido',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Solo gli utenti registrati possono mettere mi piace alle novel. Crea un account per mettere mi piace a questa novel.',
    'Попробуйте снова или позже ({0})': 'Riprova più tardi ({0})',
  },

  polish: {
    'Новости и обновления платформы {0}.': 'Nowości i aktualizacje platformy {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Szukaj',
    'Профиль': 'Profil',
    'Библиотека': 'Biblioteka',
    'Создать новеллу': 'Stwórz powieść',
    'Оплата': 'Płatności',
    'Блог': 'Blog',
    'Новости': 'Aktualności',
    'Стать автором': 'Zostań autorem',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Odkryj swój wszechświat',
    'Открыть меню': 'Otwórz menu',
    'Закрыть меню': 'Zamknij menu',
    'Меню навигации': 'Menu nawigacji',
    'Закрыть уведомление': 'Zamknij powiadomienie',
    'Читать': 'Czytaj',
    'Важные новости': 'Ważne aktualności',
    'Нажмите, чтобы прочитать': 'Kliknij, aby przeczytać',
    'Сообщить об ошибке / задать вопрос': 'Zgłoś błąd / zadaj pytanie',
    /* SiteFooter */
    'О нас': 'O nas',
    'Сотрудничество': 'Współpraca',
    'Пользовательское соглашение': 'Regulamin',
    'Политика конфиденциальности': 'Polityka prywatności',
    'Согласие на Cookie': 'Zgoda na pliki cookie',
    'Публичная оферта': 'Oferta publiczna',
    'Политика возврата': 'Polityka zwrotów',
    'Правообладателям': 'Prawa autorskie i DMCA',
    'Индивидуальный предприниматель': 'Przedsiębiorca indywidualny',
    /* ReportModal */
    'Сообщение отправлено': 'Wiadomość wysłana',
    'Ошибка при отправке': 'Błąd podczas wysyłania',
    'Отправить': 'Wyślij',
    'Мои обращения': 'Moje zgłoszenia',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Opisz problem lub zadaj pytanie — administrator wkrótce Ci odpowie.',
    'Ваше сообщение...': 'Twoja wiadomość...',
    'Отправка...': 'Wysyłanie...',
    'Загрузка...': 'Ładowanie...',
    'Обращений нет': 'Brak zgłoszeń',
    'Ответ администратора:': 'Odpowiedź administratora:',
    'Администратор скоро Вам ответит': 'Administrator wkrótce Ci odpowie',
    /* Modal */
    'Закрыть': 'Zamknij',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'Kontynuując korzystanie z witryny,',
    'соглашаетесь': 'zgadzasz się',
    'на использование файлов Cookie': 'na wykorzystywanie plików cookie',
    'Принять': 'Akceptuję',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Aktualizacje i ogłoszenia platformy',
    'Новостей пока нет': 'Nie ma jeszcze aktualności',
    'Новое': 'Nowe',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'Aktualności, nowości i artykuły od zespołu AI Novel',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Trwają prace techniczne. Wróć proszę później.',
    'Обновить': 'Odśwież',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Nie znaleziono użytkownika',
    'Имя пользователя должно содержать от 3 до 20 символов': 'Nazwa użytkownika musi mieć od 3 do 20 znaków',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'Nazwa użytkownika może zawierać tylko litery, cyfry i podkreślenia',
    'Имя пользователя уже зарегистрировано': 'Ta nazwa użytkownika jest już zajęta',
    'Неверное имя пользователя или пароль': 'Nieprawidłowa nazwa użytkownika lub hasło',
    'Новелла не найдена': 'Nie znaleziono powieści',
    'Неверный ключ администратора': 'Nieprawidłowy klucz administratora',
    'Неверный код верификации': 'Nieprawidłowy kod weryfikacyjny',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Tylko zarejestrowani użytkownicy mogą polubić powieści. Załóż konto, aby polubić tę powieść.',
    'Попробуйте снова или позже ({0})': 'Spróbuj ponownie później ({0})',
  },

  portuguese: {
    'Новости и обновления платформы {0}.': 'Notícias e novidades da plataforma {0}.',
    /* SiteHeader — nav */
    'Поиск': 'Buscar',
    'Профиль': 'Perfil',
    'Библиотека': 'Biblioteca',
    'Создать новеллу': 'Criar novel',
    'Оплата': 'Pagamento',
    'Блог': 'Blog',
    'Новости': 'Notícias',
    'Стать автором': 'Torne-se autor',
    /* SiteHeader — chrome */
    'Открой свою вселенную': 'Descubra o seu universo',
    'Открыть меню': 'Abrir menu',
    'Закрыть меню': 'Fechar menu',
    'Меню навигации': 'Menu de navegação',
    'Закрыть уведомление': 'Fechar notificação',
    'Читать': 'Ler',
    'Важные новости': 'Notícias importantes',
    'Нажмите, чтобы прочитать': 'Toque para ler',
    'Сообщить об ошибке / задать вопрос': 'Relatar um erro / fazer uma pergunta',
    /* SiteFooter */
    'О нас': 'Sobre nós',
    'Сотрудничество': 'Parcerias',
    'Пользовательское соглашение': 'Termos de Uso',
    'Политика конфиденциальности': 'Política de Privacidade',
    'Согласие на Cookie': 'Consentimento de Cookies',
    'Публичная оферта': 'Oferta Pública',
    'Политика возврата': 'Política de Reembolso',
    'Правообладателям': 'Direitos autorais e DMCA',
    'Индивидуальный предприниматель': 'Empresário individual',
    /* ReportModal */
    'Сообщение отправлено': 'Mensagem enviada',
    'Ошибка при отправке': 'Falha ao enviar',
    'Отправить': 'Enviar',
    'Мои обращения': 'Minhas solicitações',
    'Опишите проблему или задайте вопрос — администратор скоро Вам ответит.': 'Descreva o problema ou faça uma pergunta — um administrador vai responder em breve.',
    'Ваше сообщение...': 'Sua mensagem...',
    'Отправка...': 'Enviando...',
    'Загрузка...': 'Carregando...',
    'Обращений нет': 'Nenhuma solicitação ainda',
    'Ответ администратора:': 'Resposta do administrador:',
    'Администратор скоро Вам ответит': 'Um administrador vai responder em breve',
    /* Modal */
    'Закрыть': 'Fechar',
    /* CookieBanner */
    'Продолжая использовать сайт, вы': 'Ao continuar usando o site, você',
    'соглашаетесь': 'concorda',
    'на использование файлов Cookie': 'com o uso de cookies',
    'Принять': 'Aceitar',
    /* NewsPage */
    'Обновления и анонсы платформы': 'Novidades e anúncios da plataforma',
    'Новостей пока нет': 'Ainda não há notícias',
    'Новое': 'Novo',
    /* BlogPage */
    'Новости, обновления и статьи от команды AI Novel': 'Notícias, novidades e artigos da equipe AI Novel',
    /* App — maintenance */
    'Проводятся технические работы. Пожалуйста вернитесь позже.': 'Estamos em manutenção programada. Volte mais tarde.',
    'Обновить': 'Atualizar',
    /* apiUtils — server errors */
    'Пользователь не найден': 'Usuário não encontrado',
    'Имя пользователя должно содержать от 3 до 20 символов': 'O nome de usuário deve ter entre 3 e 20 caracteres',
    'Имя пользователя может содержать только буквы, цифры и нижнее подчёркивание': 'O nome de usuário só pode conter letras, números e sublinhados',
    'Имя пользователя уже зарегистрировано': 'Este nome de usuário já está em uso',
    'Неверное имя пользователя или пароль': 'Nome de usuário ou senha incorretos',
    'Новелла не найдена': 'Novel não encontrada',
    'Неверный ключ администратора': 'Chave de administrador inválida',
    'Неверный код верификации': 'Código de verificação inválido',
    'Только зарегистрированные пользователи могут лайкать новеллы. Пожалуйста, создайте аккаунт, чтобы лайкать эту новеллу.': 'Só usuários cadastrados podem curtir novels. Crie uma conta para curtir esta novel.',
    'Попробуйте снова или позже ({0})': 'Tente novamente mais tarde ({0})',
  },
};

export default chrome;
